import { useExperimentFlag } from '../../../../utils/useExperimentFlag';
import { useCurrentUser } from '../../../users/useCurrentUser';

export const useIsBloggerRegistrationEnabled = () => {
    const currentUser = useCurrentUser();
    const enabledForProfile = currentUser?.bloggerRegistrationEnabled;
    const isFlagEnabled = Number(useExperimentFlag('bloggers_registration_enabled')) === 1;

    return Boolean(isFlagEnabled || enabledForProfile);
};
